export default __webpack_public_path__ + "static/media/INFJ.d518d993.svg";